export default "__VITE_ASSET__1888c923__"